<cbc-container [isLoading]="isLoading" 
[showContainer]="!isLoading" 
title="Ofertas de Consultas e Procedimentos"
description="Gerencie suas ofertas de serviços">
</cbc-container>

@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">

  <div style="max-width: 1024px; text-align: left; width: 100%">
    <mat-accordion>
      @for (serviceOffering of serviceOfferingProviderPJList; track $index) {
      <mat-expansion-panel
        (opened)="panelOpenState.set(true)"
        (closed)="panelOpenState.set(false)"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="mat-panel-title-custom">
              {{ serviceOffering.id }} - {{ serviceOffering.professionName
              }}<br />
              <strong>Especialidade: </strong> {{ serviceOffering.specialty }}
              <br />
              <strong>Áreas de Atuação:</strong>
              {{ serviceOffering.activityAreas }}
            </div>

            <div class="observationText">
              <div>
                @if(serviceOffering.publicationDate) {Data da Publicação:
                {{ serviceOffering.publicationDate | date : "dd/MM/yyyy " }}

                @if(serviceOffering.expirationPublicationDate) { - Valido até:
                {{
                  serviceOffering.expirationPublicationDate
                    | date : "dd/MM/yyyy "
                }}} } @else {Não Publicado }
              </div>
              <div style="flex: 1 0 50px; place-self: self-end">
                {{ serviceOffering.status! | enumDescription }}
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-panel-description style="flex-wrap: wrap">
          <div class="field-row">
            <span>Data da criação:</span>
            <span class="field-dots"></span>
            <strong class="field-value">{{
              serviceOffering.creationDate | date : "dd/MM/yyyy '-' hh:mm"
            }}</strong>
          </div>

          <div class="field-row">
            <span>Atendimento à adulto:</span>
            <span class="field-dots"></span>
            <strong class="field-value">{{
              serviceOffering.adultCare ? "Sim" : "Não"
            }}</strong>
          </div>

          <div class="field-row">
            <span>Atendimento pediátrico:</span>
            <span class="field-dots"></span>
            <strong class="field-value">{{
              serviceOffering.pediatricCare ? "Sim" : "Não"
            }}</strong>
          </div>
          <div class="field-row">
            <span>Formato Online:</span>
            <span class="field-dots"></span>
            <strong class="field-value">{{
              serviceOffering.serviceFormatOnLine ? "Sim" : "Não"
            }}</strong>
          </div>
          <div class="field-row">
            <span>Formato Presencial:</span>
            <span class="field-dots"></span>
            <strong class="field-value">{{
              serviceOffering.serviceFormatPresential ? "Sim" : "Não"
            }}</strong>
          </div>
          <div class="field-row">
            <span>Endereço:</span>
            <span class="field-dots"></span>
            @if(serviceOffering.address?.street) {
            <strong class="field-value"
              >{{ serviceOffering.address?.street }},
              {{ serviceOffering.address?.number }} -
              {{ serviceOffering.address?.city }}/{{
                serviceOffering.address?.state
              }}</strong
            >}
          </div>
          <div>
            Disponibilidade:
            <app-availability
              [availabilityShow]="serviceOffering.availability"
            ></app-availability>
          </div>

          <div class="field-row">
            <span>Valor Proposto:</span>
            <span class="field-dots"></span>
            <strong class="field-value">
              {{
                serviceOffering.amount
                  ? (serviceOffering.amount
                    | currency : "BRL" : "symbol" : "1.2-2")
                  : "-"
              }}
            </strong>
          </div>
          @if(serviceOffering.amount){
          <div class="field-row">
            <span>Unidade:</span>
            <span class="field-dots"></span>
            <strong class="field-value">{{
              serviceOffering.billingUnit! | enumDescription
            }}</strong>
          </div>
          }
          <div class="field-row">
            <span>Descrição:</span>
            <span class="field-dots"></span>
            <strong class="field-value">{{
              serviceOffering.description
            }}</strong>
          </div>
          <div class="field-row">
            <span>Status:</span>
            <span class="field-dots"></span>
            <strong class="field-value">{{
              serviceOffering.status! | enumDescription
            }}</strong>
          </div>
          <div class="field-row">
            <span>Atendimento plantonista:</span>
            <span class="field-dots"></span>
            <strong class="field-value">{{
              serviceOffering.emergencyService ? "Sim" : "Não"
            }}</strong>
          </div>

          <div>
            Disponibilidade Plantonista:
            <app-availability
              [availabilityShow]="serviceOffering.emergencyServiceAvailability"
            >
            </app-availability>
          </div>
          <div class="footerButtons">

            @if(!serviceOffering.publicationDate){
            <button mat-flat-button (click)="publish(serviceOffering.id!.toString())">
              Publicar
              <mat-icon>rocket_launch</mat-icon></button
            >}
            <button
              mat-button
              [routerLink]="['serviceOfferingForm', serviceOffering.id]"
            >
              Alterar
              <mat-icon>published_with_changes</mat-icon>
            </button>
            <button
              mat-button
              (click)="deleteServiceOffering(serviceOffering.id!.toString())"
            >
              Excluir
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </mat-panel-description> </mat-expansion-panel
      >}
    </mat-accordion>
    <button mat-button routerLink="serviceOfferingForm">
      Criar uma Oferta de Consultas
      <mat-icon>edit_document</mat-icon>
    </button>
  </div>
</div>
}
